<template>
  <form-component>
    <form
      novalidate="novalidate"
      @submit.prevent="doSave"
    >
      <input-text
        id="old_password"
        v-model="old_password"
        v-validate="'required'"
        name="old_password"
        data-vv-name="old_password"
        data-vv-as="current password"
        label="Current Password"
        type="password"
        required
        :error="errors.first('old_password')"
      />
      <input-text
        id="password"
        v-model="password"
        v-validate="'required'"
        name="password"
        data-vv-name="password"
        data-vv-as="new password"
        label="New Password"
        type="password"
        required
        :error="errors.first('password')"
      />
      <input-text
        id="confirm"
        v-model="confirm"
        v-validate="'required'"
        name="confirm"
        data-vv-name="confirm"
        data-vv-as="confirm new password"
        label="Confirm New Password"
        type="password"
        required
        :error="errors.first('confirm')"
      />


      <button
        v-if="showSaveButton"
        type="submit"
        class="btn btn--primary mt-4"
      >
        <processing-text :prc="saving">
          Save Changes
        </processing-text>
      </button>
    </form>
  </form-component>
</template>

<script>
import FormComponent from '@/components/FormComponent.vue';
import ProcessingText from '@/components/ProcessingText.vue';
import InputText from '@/components/inputs/InputText.vue';
import UserClient from '@/api/UserClient';

export default {
  name: 'ChangePasswordForm',
  components: {
    FormComponent,
    ProcessingText,
    InputText,
  },
  props: {
    showSaveButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      saving: false,
      userClient: new UserClient(this.$http),

      old_password: '',
      password: '',
      confirm: '',
    };
  },
  methods: {
    reset() {
      this.saving = false;
      this.old_password = '';
      this.password = '';
      this.confirm = '';
    },
    doSave() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.errors.clear();

          if (this.old_password && this.password && this.confirm) {
            if (this.password !== this.confirm) {
              return this.$globals.showError('Please make sure your confirm password matches!');
            }

            this.saving = true;
            await this.userClient.putCurrentUserUpdatePassword(this.old_password, this.password);

            this.old_password = '';
            this.password = '';
            this.confirm = '';
            this.saving = false;

            this.$globals.showSuccess('Password Saved!');
            this.$globals.scrollToTop();
          }
        } else {
          // for outer save buttons pass back something to stop spinning
          this.$globals.scrollToFirstError(this.$validator);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
